import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("fti_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem("fti_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    // Two-step path: backend returns requires_2fa=true + a partial token.
    // We DON'T store anything yet — the caller (Login page) handles the
    // TOTP prompt and then calls completeLogin2fa() with the 6-digit code.
    if (r.data.requires_2fa) {
      return { requires2fa: true, partialToken: r.data.partial_token, user: r.data.user };
    }
    localStorage.setItem("fti_token", r.data.token);
    setUser(r.data.user);
    return { requires2fa: false, user: r.data.user };
  };

  const completeLogin2fa = async (partialToken, code) => {
    const r = await api.post("/auth/login/2fa", { partial_token: partialToken, code });
    localStorage.setItem("fti_token", r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };

  const refreshUser = async () => {
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
      return r.data;
    } catch { return null; }
  };

  const register = async (payload) => {
    const r = await api.post("/auth/register", payload);
    if (r.data.token) {
      localStorage.setItem("fti_token", r.data.token);
      setUser(r.data.user);
    }
    return r.data;
  };

  const logout = () => {
    localStorage.removeItem("fti_token");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, completeLogin2fa, register, logout, refreshUser }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
